export const additionalSectionNames = {
  Produktvorteile: $localize`:|additional section name product benefits @@product-addition-section-name.product-benefits:Product benefits`,
  Beschreibung: $localize`:|additional section name description @@product-addition-section-name.description:Description`
};
